import React from 'react';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const ProdGridCreateSO =(props)=>{
    const {formObject, viewData} = props

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const valLDT = formObject.getValueFromKey(viewData, "dataList.valLDT", "");
    const dId = formObject.getValueFromKey(viewData, "dataList.dId", "");
    // let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

    //TODO add support for converting the string based style to a react style
    //Original code below which is not working because of style
    // <div className={viewData.dataList.valCssClass ? viewData.dataList.valCssClass : ''} 
    // style={viewData.dataList.valCssStyle ? viewData.dataList.valCssStyle : ''}>{viewData.valF}</div>
    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    action={{actionId: "refresh", actionName: "prodTask", 
                    actionParam: { actionType: "createSO",dtId: valLDT, dId: dId, rowKey: viewData.val }}}
                    text={<SarasTrans value="Create SO" />} />
            </div>
        </div>
    )
}

export default ProdGridCreateSO
